import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=c73ee77c&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=c73ee77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73ee77c",
  null
  
)

export default component.exports